<div class="{{isLoading}}"></div>
<div class="snackbar {{show}}">{{message}}</div>
<section class="login-hero">

    <div class="actual-form" *ngIf="!sent">

        <h1>Forgot Password?</h1>

        <form  class="login-hero">
            <input class="input-text" type="email" placeholder="Email" name="email" [(ngModel)]="email">
            <br>
            <!-- <input class="input-text" type="password" placeholder="Password" name="password" [(ngModel)]="params.password"> -->
            <button (click)="getOtp()" *ngIf="isLoading!='loading'">Send OTP</button>
            <button (click)="getOtp()" color="gray" disabled *ngIf="isLoading=='loading'">Send OTP</button>
        </form>
        <br>
        <p>Dont have an account <a href="/signup">Register here</a></p>

    </div>

    <div class="actual-form" *ngIf="sent">

        <h1>Reset Password</h1>

        <form  class="login-hero">
            <input class="input-text" type="password" placeholder="OTP" name="password" [(ngModel)]="otp">
            <!-- <input class="input-text" type="email" placeholder="Email" name="email" [(ngModel)]="email"> -->
            <br>
            <input class="input-text" type="password" placeholder="New Password" name="password" [(ngModel)]="newPassword">
            <br>
            <button (click)="resetPassword()" *ngIf="isLoading!='loading'">Reset Password</button>
            <button (click)="resetPassword()" color="gray" disabled *ngIf="isLoading=='loading'">Reset Password</button>
        </form>
        <br>

        <p>Didnt recieved your otp click here to <a href="#"><p (click)="getOtp()">send agaian</p></a></p>
        <p>Dont have an account <a href="/signup">Register here</a></p>

    </div>

</section>